// AnalyticsListener.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./utils/analytics";

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    trackPageView(pagePath);
  }, [location.pathname, location.search]);

  return null;
}
